import React, { useEffect, useRef, useState } from "react";
import NxtbnDrawer from "../drawer";
import useApi from "../../api";
import { NXSearch } from "../../icons";

interface VariantChooserProps {
  parentSearchTerm: any;
  isOpen: boolean;
  onClose: () => void;
  onSelect: (variant: any) => void;
}

function VariantChooser({ parentSearchTerm, isOpen, onClose, onSelect }: VariantChooserProps) {
  const api = useApi();
  const searchRef = useRef<any>();
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [searchResult, setSearchResult] = useState<any>([]);
  const [selectedVariant, setSelectedVariant] = useState<any>(null);


  useEffect(() => {
    if (searchRef.current) {
      searchRef.current.focus();
    }
  },[searchQuery]);

  useEffect(() => {
    setSearchQuery(parentSearchTerm);
    const query = { "search": parentSearchTerm };
    api.getProductVariants(query).then(
      (response) => setSearchResult(response),
      (error) => console.error(error)
    );
  }, [parentSearchTerm]);


  const handleSearch = (e: any) => {
    setSearchQuery(e.target.value);
    const query = { "search": e.target.value || parentSearchTerm };
    api.getProductVariants(query).then(
      (response) => setSearchResult(response),
      (error) => console.error(error)
    );
  };


  const toggleVariantSelect = (e: React.ChangeEvent<HTMLInputElement>, variant: any) => {
    if (selectedVariant && variant?.id === selectedVariant?.id) {
      setSelectedVariant(null)
    }else{
      setSelectedVariant(variant)
    }

  };


  return (
    <NxtbnDrawer isOpen={isOpen} onClose={onClose} title="VariantChooser">
      <div className="relative w-full mb-4">
        <NXSearch className="absolute top-1/2 left-4 transform -translate-y-1/2" />
        <input
          ref={searchRef}
          type="text"
          placeholder="Search variants"
          onChange={handleSearch}
          value={searchQuery}
          className="p-[12px] focus:border-green-500 bg-secondary-50 rounded-lg border-none outline-none pl-[3.1rem] w-full"

        />

      </div>
      <div className="p-4 overflow-y-auto h-[70vh] bg-gray-50">
        {searchResult?.results?.map((variant:any, index:number)=>(
          <div key={index} className="border p-4 mb-6 bg-white">
            <label htmlFor={variant.id} className="">
              <div className="flex flex-col gap-4">
                <div className="flex gap-4">
                  <input 
                    id={variant.id} 
                    name="product_variant" 
                    type="checkbox"
                    checked={selectedVariant && selectedVariant?.id === variant?.id}
                    onChange={(e)=>toggleVariantSelect(e, variant)} />

                  <div className="flex justify-between gap-6">
                    <div className="text-base-300">#ID {variant.id}</div>
                    <div>{variant?.name}</div>
                  </div>
                </div>
                <div className="ml-6">{variant.sku}</div>
              </div>
            </label>

          </div>
        ))}
      </div>

      <div className="flex items-center justify-between p-4 bg-gray-50 border-t">
        <span className="text-sm text-gray-500"> {selectedVariant && 'A variant selected'}</span>
        <div className="flex space-x-4">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-gray-600 bg-white border rounded-md hover:bg-gray-100"
          >
            Cancel
          </button>
          <button
            onClick={() => {
              onSelect(selectedVariant)
              onClose()
            }}
            type="button"
            disabled={selectedVariant ? false : true}
            className={`px-4 py-2 text-sm font-medium text-white rounded-md ${
              selectedVariant
              ?
                "bg-primary-600 hover:bg-primary-500" : "bg-gray-300"
            }`}
          >
            Add
          </button>
        </div>
      </div>
    </NxtbnDrawer>
  );
}

export default VariantChooser;